import { apiConfig } from 'config';
import { fetchdata } from 'apis/FetchData';
import { handle420 } from 'apis/HandleError';
import moment from 'moment';

const default_from = moment().subtract(1, 'months').toISOString();

export function getActions(status = 'all', fromStr = default_from, toStr = 'now') {
  let url = apiConfig.cmServiceGetActions + '?status=' + status + '&from=' + fromStr + '&to=' + toStr;
  return fetchdata(url, {
    method: 'GET'
  }).catch((e) => {
    console.log('fetch data error = ' + e.message);
    switch (e.message) {
      case '420':
        handle420();
        break;
      default:
        throw e;
    }
    return;
  });
}
